import React from 'react';
import styled from 'styled-components';

import FlexCentered from 'components/Common/FlexCentered';
import Loading from 'components/Loading';
import Typography from 'kingpin/atoms/Typography';

import formatScreenshotTime from './formatScreenshotTime';

const Pill = styled.div`
  position: absolute;
  z-index: 2;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: var(--color-bg-secondary);
  box-shadow: var(--shadow-md);
`;

// Screenshots older than STALE_AFTER_MS: the renderer hasn't succeeded lately.
export const StaleBanner = ({ generatedAt }: { generatedAt: string }) => (
  <Pill
    style={{ top: 12, left: '50%', transform: 'translateX(-50%)' }}
    data-testid="wallboard-stale-banner"
  >
    <Typography.Body type="Body 14">
      {`Data as of ${formatScreenshotTime(generatedAt)}`}
    </Typography.Body>
  </Pill>
);

// A frame the latest render couldn't refresh (status 'stale' or 'error').
export const FrameNotUpdatedBadge = ({
  generatedAt,
}: {
  generatedAt: string;
}) => (
  <Pill style={{ bottom: 12, left: 12 }} data-testid="wallboard-frame-badge">
    <Typography.Body type="Body 12">
      {`This slide couldn't be updated. Showing ${formatScreenshotTime(
        generatedAt,
      )}`}
    </Typography.Body>
  </Pill>
);

export const FullScreenMessage = ({
  title,
  body,
  isLoading,
}: {
  title: string;
  body?: string;
  isLoading?: boolean;
}) => (
  <FlexCentered style={{ width: '100%', height: '100%' }}>
    <div style={{ textAlign: 'center', maxWidth: 560 }}>
      {isLoading && (
        <div style={{ marginBottom: 24 }}>
          <Loading />
        </div>
      )}
      <Typography.Header type="H3">{title}</Typography.Header>
      {body && (
        <div style={{ marginTop: 8 }}>
          <Typography.Body type="Body 14" color="var(--color-grey-5)">
            {body}
          </Typography.Body>
        </div>
      )}
    </div>
  </FlexCentered>
);
